import { Box } from '@mui/material';
import { getCellStyle } from './DecideColor';

// Define the monetary status theme
const MONETARY_STATUS_THEME = {
  "non-monetary": {
    bg: "#EEEEEE",
    color: "#000000",
    iconBg: "#000000",
    Icon: null,
    border: `1px solid #00000020`,
    px: 1.5,
    py: 0.5,
    borderRadius: 1,
  },
  monetary: {
    bg: "#EEEEEE",
    color: "#000000",
    iconBg: "#000000",
    Icon: null,
    border: `1px solid #00000020`,
    px: 1.5,
    py: 0.5,
    borderRadius: 1,
  },
};

export const RatePlanOrAttributesColumn = ({ 
  charge, 
  chargeCount, 
  grant, 
  grantsCount, 
  usage, 
  usageCount, 
  offerOrPolicy, 
  provisioning, 
  serviceUsage,
  provisioningIsCurrency, // Add this prop to determine if provisioning is monetary
  serviceUsageIsCurrency  // Add this prop to determine if serviceUsage is monetary
}) => {
    
    // Helper function to determine status type
    const getStatusType = (isCurrency) => {
        return isCurrency ? 'monetary' : 'non-monetary';
    };

    // StatusBadge component (you may need to import this from your components)
    const StatusBadge = ({ value, customTheme }) => (
        <Box
            sx={{
                backgroundColor: customTheme.bg,
                color: customTheme.color,
                border: customTheme.border,
                px: customTheme.px,
                py: customTheme.py,
                borderRadius: customTheme.borderRadius,
                fontSize: '14px',
                fontWeight: '600',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {value?value:"-"}
        </Box>
    );

    return (
        <Box sx={(theme) => ({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '1px',
        })}>
            {charge && (
                <span style={{
                    borderRadius: '0.45rem',
                    fontSize: '12px',
                    ...getCellStyle(charge, offerOrPolicy ? "" : "Offer"),
                    padding: '5px',
                    marginRight: 'auto', 
                }}>
                    {offerOrPolicy ? (
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="mb-0 me-1 ps-1 badge-for-offer-count ">{chargeCount}</div>
                            <div className="fw-semibold">{charge}</div>
                        </div>
                    ) : charge}
                </span>
            )}

            {usage && (
                <span style={{
                    borderRadius: '0.45rem',
                    fontSize: '12px',
                    ...getCellStyle(usage, offerOrPolicy ? "" : "Offer"),
                    padding: offerOrPolicy ? '4px' : '5px',
                }}>
                    {offerOrPolicy ? (
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="mb-0 me-1 ps-1 badge-for-offer-count ">{usageCount}</div>
                            <div className="fw-semibold">{usage}</div>
                        </div>
                    ) : usage}
                </span>
            )}

            {grant && (
                <span className={offerOrPolicy ? "badge-for-order" : ""} style={{
                    borderRadius: '0.45rem',
                    fontSize: '12px',
                    color:'#fff',
                    ...getCellStyle(grant, offerOrPolicy ? "" : "Offer"),
                    padding: offerOrPolicy ? '4px' : '5px',
                    marginLeft: 'auto', 
                }}>
                    {offerOrPolicy ? (
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="mb-0 me-1 ps-1 badge-for-offer-count ">{grantsCount}</div>
                            <div className="fw-semibold">{grant}</div>
                        </div>
                    ) : grant}
                </span>
            )}

            {provisioning && (
                <Box sx={{ marginRight: 'auto', marginLeft: 'auto' }}>
                    <StatusBadge 
                        value={provisioning}
                        customTheme={MONETARY_STATUS_THEME[getStatusType(provisioningIsCurrency)]}
                    />
                </Box>
            )}

            {serviceUsage && (
                <Box sx={{ marginLeft: 'auto',marginRight: 'auto' }} className="me-2">
                    <StatusBadge 
                        value={serviceUsage}
                        customTheme={MONETARY_STATUS_THEME[getStatusType(serviceUsageIsCurrency)]}
                    />
                </Box>
            )}
        </Box>
    )
}